import { ConditionalPartial } from '../../../utils';
import { CreateContactRequestDto } from './create-contact.request.dto';

/**
 * DTO for updating contact fields
 * All fields are optional for partial updates
 */
export class UpdateContactRequestDto extends ConditionalPartial(CreateContactRequestDto) {}
